var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],staticClass:"global-loading"},[_c('Spin',{attrs:{"size":"large"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }